<template>
    <button class="sound-button" :class="[{ 'btn-play': !isPlaying, 'btn-pause' : isPlaying }]" @click="togglePlay(file)">

        <svg class="circle__progress" width="100%" height="100%" viewPort="0 0 100 100">
            <circle id="percent" r="46%" cx="50%" cy="50%" stroke-dasharray="293%" :stroke-dashoffset="`${progress}%`"></circle>
        </svg>

        <SvgNote
            class="icon-note"
            v-if="!isPlaying"
            double
        ></SvgNote>

        <svg
            class="icon-play"
            v-if="!isPlaying"
            viewBox="0 0 52 58"
        >
            <path d="M48 22.0718C53.3333 25.151 53.3333 32.849 48 35.9282L12 56.7128C6.66667 59.792 -2.92617e-06 55.943 -2.65698e-06 49.7846L-8.39932e-07 8.21539C-5.70739e-07 2.05699 6.66667 -1.79202 12 1.28718L48 22.0718Z" />
        </svg>

        <svg
            class="icon-pause"
            v-if="isPlaying"
            viewBox="0 0 53 53"
        >
            <path d="M10.93 0h.15c6.03 0 10.93 4.89 10.93 10.93v31.15c0 6.03-4.89 10.93-10.93 10.93h-.15C4.9 53.01 0 48.12 0 42.08V10.93C0 4.89 4.89 0 10.93 0ZM31 10.93C31 4.9 35.97 0 42 0s11 4.89 11 10.93v31.15c0 6.03-4.97 10.93-11 10.93s-11-4.89-11-10.93V10.93Z" />
        </svg>

    </button>
</template>

<script>
    import SvgNote from "./SvgNote";

    export default {
        name: "SoundButton",
        components: { SvgNote }
    }
</script>

<script setup>

    import useSound from "../composables/useSound";
    import { useMainStore } from "../stores/main";
    import { storeToRefs } from "pinia";
    import { computed, ref } from "vue";

    const props = defineProps(["id", "file"]);
    const emits = defineEmits(["play", "stop"])

    let store = useMainStore();
    let { currentlyPlaying } = storeToRefs(store);

    let { playSound, fadeAndStopPlaying } = useSound();
    let playing = ref(false);
    let currentTime = ref(0);
    let duration = ref(1);
    let isPlaying = computed ( () => playing.value );
    let sound = ref(null);

    /* Magic numbers explained
    - The circle is 100% width/height and cx and cy are used to display it in the middle of the svg viewport.
    - The r attribute is the radius. It would have been 50% IF svg didn't have the bad habit of displaying borders
    midway on a shape's edge (half inside, half outside), which causes it to be cut out by the svg viewport if we
    don't give it some allowance. Border's width is 8%, so 100% - 8% / 2 = 46%.
    - We need the dasharray to be the diameter of the circle. Formulae is Math.PI * r * 2, so 292ish (rounded up to 293)
    - Finally, the dashoffset will be a value ranging from 293 (0%) and 0 (100%). This is the property we are animating to display progress.
    */
    let progress = computed( () => {
        if(!isPlaying.value) return 293; // bail

        let percent = currentTime.value / duration.value * 100;
        return Math.ceil(((100 - percent) / 100) * 293);
    });

    function startTracking ()
    {
        if (sound.value)
        {
            duration.value = sound.value.duration();
            trackTime();
        }

    }

    function trackTime ()
    {
        if (playing.value)
        {
            requestAnimationFrame (() => trackTime());


            currentTime.value = sound.value.seek();
        }
    }
    const togglePlay = function(track) {

        // // if not already playing this sound
        // if(playing.value !== currentlyPlaying.value?.src) {
        //     let sound = playSound(track);
        //     playing.value = sound.src;
        //
        //     sound.addEventListener('timeupdate', (event) => {
        //         currentTime.value = sound.currentTime;
        //     });
        //
        //     sound.addEventListener('ended', (event) => {
        //         stopSound();
        //         playing.value = false;
        //         currentTime.value = 0;
        //     });
        // } else {
        //     stopSound();
        //     playing.value = false;
        //     currentTime.value = 0;
        // }

        if (!playing.value)
        {
            sound.value = playSound(track, "playlist-button-" + props.id);
            playing.value = true;
            emits("play", () => togglePlay(track), track);

            sound.value.on('play', (event) =>
            {
                startTracking();

            });

            sound.value.on('end', (event) =>
            {
                playing.value = false;
                currentTime.value = 0;
                emits("stop");
            });
        }
        else
        {
            fadeAndStopPlaying("playlist-button-" + props.id);
            playing.value = false;
            sound.value = null;
            duration.value = 1; //since we will be diving by this, we need to make sure it's not 0
            emits("stop");

        }
    }


</script>
